import { Eye, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';
import { MerchandisingCollection } from '@/services/MerchandisingCollectionsService';

interface CollectionCardProps {
  collection: MerchandisingCollection;
  onRemove: (collection: MerchandisingCollection) => void;
}

export function CollectionCard({ collection, onRemove }: CollectionCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.MerchandisingCollections.components.CollectionCard',
  });

  return (
    <Card className="group transition-shadow hover:shadow-md">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-lg">{collection.name}</CardTitle>
            <CardDescription className="line-clamp-2">
              {collection.description}
            </CardDescription>
          </div>
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        <div className="space-y-1 text-sm text-muted-foreground">
          <span className="block">
            {collection.slicesCount} {t('slices')}
          </span>

          <span className="block">
            {t('createdAt')}{' '}
            {new Date(collection.createdAt).toLocaleDateString('pt-BR')}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <Button asChild variant="outline" size="sm" className="flex-1">
            <Link
              to={ROUTE_PATHS.MERCHANDISING_COLLECTION.replace(
                ':collectionId',
                String(collection.id),
              )}
            >
              <Eye className="mr-2 h-4 w-4" />
              {t('slicesButtonLabel')}
            </Link>
          </Button>

          <Button
            variant="outline"
            size="sm"
            className="text-destructive hover:text-destructive"
            onClick={() => onRemove(collection)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
